import React from 'react'
import PureText from './components/PureText'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import copy from '@/assets/icon/AI／icon／copy.png'
import { message, Button } from 'antd'
const copyToClipboard = (code: string) => {
  navigator.clipboard.writeText(code).then(() => {
    message.success('复制成功')
  })
}
export const getMarkdownRenderConfig = (styles: Record<string, string>) => {
  return {
    // 段落
    p: ({ children }) => (
      <p
        style={{
          margin: '2px 0',
          fontSize: 15,
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
        }}
      >
        {children}
      </p>
    ),

    // 标题
    h1: ({ children }) => (
      <h1
        style={{
          marginTop: 8,
          marginBottom: 8,
          fontWeight: 600,
          fontSize: '2em',
        }}
      >
        {children}
      </h1>
    ),
    h2: ({ children }) => (
      <h2
        style={{
          marginTop: 8,
          marginBottom: 8,
          fontWeight: 600,
          fontSize: '1.5em',
        }}
      >
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3
        style={{
          marginTop: 8,
          marginBottom: 8,
          fontWeight: 600,
          fontSize: '1.25em',
        }}
      >
        {children}
      </h3>
    ),
    h4: ({ children }) => (
      <h4
        style={{
          marginTop: 8,
          marginBottom: 8,
          fontWeight: 600,
          fontSize: '1.125em',
        }}
      >
        {children}
      </h4>
    ),
    h5: ({ children }) => (
      <h5
        style={{
          marginTop: 8,
          marginBottom: 8,
          fontWeight: 800,
          fontSize: '14px',
        }}
      >
        {children}
      </h5>
    ),
    h6: ({ children }) => (
      <h6
        style={{
          marginTop: 8,
          marginBottom: 8,
          fontWeight: 800,
          fontSize: '12px',
        }}
      >
        {children}
      </h6>
    ),

    // 列表
    ul: ({ children }) => (
      <ul
        style={{
          paddingLeft: '2em',
          marginTop: '0em',
          marginBottom: '0.25em',
          listStyleType: 'disc',
          wordBreak: 'break-word',
        }}
      >
        {children}
      </ul>
    ),
    ol: ({ children }) => (
      <ol
        style={{
          paddingLeft: '2em',
          marginTop: '0em',
          marginBottom: '0em',
          listStyleType: 'decimal',
          wordBreak: 'break-word',
        }}
      >
        {children}
      </ol>
    ),
    li: ({ children }) => (
      <li style={{ margin: 0, wordBreak: 'break-word' }}>{children}</li>
    ),

    // 代码块
    code: ({ children, className }) => {
      const match = /language-(\w+)/.exec(className || '')
      const language = match ? match[1] : 'plaintext'

      // 判断是行内还是块级
      const isInline = !className

      if (isInline) {
        // ✅ 行内代码样式
        return <code className={styles.codeInline}>{children}</code>
      }
      // ✅ 多行代码块样式
      return (
        <div>
          <div className={styles.languageHeader}>
            <span className={styles.languageLabel}>{language}</span>
            <Button
              onClick={() => copyToClipboard(children as string)}
              style={{
                border: 'none',
                background: 'transparent',
                fontSize: '0.8rem',
                color: '#343740',
              }}
            >
              <img
                src={copy}
                alt=""
                style={{
                  width: '18px',
                  height: '18px',
                }}
              />
              复制
            </Button>
          </div>
          <SyntaxHighlighter
            language={language}
            PreTag="div"
            customStyle={{
              margin: 0,
              borderBottomLeftRadius: '0.5rem',
              borderBottomRightRadius: '0.5rem',
              backgroundColor: '#F8F9FA',
            }}
          >
            {children}
          </SyntaxHighlighter>
        </div>
      )
    },
    pre: ({ children }) => <pre className={styles.codeBlock}>{children}</pre>,

    // 表格
    table: ({ children }) => (
      <div style={{ overflowX: 'auto', marginBottom: 16 }}>
        <table
          style={{
            borderSpacing: 0,
            borderCollapse: 'collapse',
            width: '100%',
          }}
        >
          {children}
        </table>
      </div>
    ),
    th: ({ children }) => (
      <th style={{ padding: '6px 13px', border: '1px solid #d0d7de' }}>
        {children}
      </th>
    ),
    td: ({ children }) => (
      <td style={{ padding: '6px 13px', border: '1px solid #d0d7de' }}>
        {children}
      </td>
    ),
    tr: ({ children, index }: any) => (
      <tr style={index % 2 === 1 ? { backgroundColor: '#f6f8fa' } : {}}>
        {children}
      </tr>
    ),

    // 引用
    blockquote: ({ children }) => (
      <blockquote
        className={styles.thinkBlock}
        style={{
          backgroundColor: '#f9fafb',
          borderLeft: '4px solid #cbd5e1',
          padding: '0.75rem 1rem',
          borderRadius: '0.5rem',
          fontSize: '0.95rem',
          color: '#61666b',
          position: 'relative',
          wordBreak: 'break-word', // 自动换行
        }}
      >
        {children}
      </blockquote>
    ),

    // 自定义元素
    // think: ({ children }) => children,
    tool: ({ children }) => <div className={styles.toolTag}>{children}</div>,
    // ref: ({ children }) => <div className={styles.refTag}>{children}</div>,
  }
}
